import { render, staticRenderFns } from "./reseller-contract-ledger.vue?vue&type=template&id=4e6c1d22&"
import script from "./reseller-contract-ledger.vue?vue&type=script&lang=js&"
export * from "./reseller-contract-ledger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports